module.exports = __webpack_public_path__ + "img/page_organisme.04916e2a.jpg";